'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

function createWithStateProps(useContexts, options) {
  const strict = true;
  return function withStateProps(Component) {
    const Node = forwardRef((props, ref) => {
      const stateProps = {};
      for (const useContext of useContexts) {
        Object.assign(stateProps, useContext({ strict })?.stateProps);
      }
      return /* @__PURE__ */ jsx(Component, { ref, ...stateProps, ...props });
    });
    Node.displayName = Component.displayName || Component.name;
    return Node;
  };
}

export { createWithStateProps };
